(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10621],{

/***/ 50831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function PhoneIcon({ color  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 25 25",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_1_8812",
                style: {
                    maskType: "alpha"
                },
                width: "25",
                height: "25",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H25V25H0z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_1_8812)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: color ?? "#323175",
                    fillRule: "evenodd",
                    d: "M21.708 17.014l-2.079-2.08c-.582-.581-1.496-.581-1.995 0l-2.079 1.996c-1.497-.25-3.243-1.164-4.74-2.66-1.58-1.58-2.494-3.326-2.743-4.906l1.995-1.996c.582-.499.582-1.413 0-1.995L7.905 3.294a1.266 1.266 0 00-1.912 0c-.748.748-1.414 1.413-2.162 2.079-2.079 2.162.166 7.234 3.908 11.142 3.991 4.074 9.645 6.9 11.89 4.656.665-.748 1.33-1.414 2.079-2.162.582-.582.582-1.413 0-1.995zm-1.33-5.655c0 .333.332.666.665.666.416 0 .748-.333.748-.666 0-1.08-.25-2.161-.665-3.076-.416-.998-.998-1.913-1.746-2.66-.748-.75-1.663-1.331-2.66-1.747a7.561 7.561 0 00-3.077-.665c-.333 0-.666.332-.666.748 0 .333.333.665.666.665.914 0 1.746.167 2.577.5.832.332 1.58.83 2.162 1.496.665.582 1.164 1.33 1.497 2.162.332.831.499 1.663.499 2.577zm-2.661.167c0 .415.332.748.665.748.416 0 .665-.333.665-.748 0-.749-.083-1.414-.416-2.162-.249-.665-.665-1.247-1.164-1.83-.582-.498-1.164-.914-1.829-1.164-.748-.332-1.413-.415-2.162-.415-.416 0-.748.25-.748.665 0 .332.332.665.748.665.5 0 1.081.083 1.58.333.499.166.998.499 1.414.914.415.416.665.915.914 1.414.25.499.333.998.333 1.58z",
                    clipRule: "evenodd"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PhoneIcon);


/***/ }),

/***/ 83133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QrCodeImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var qrcode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92592);



function QrCodeImage({ phoneNumber , height , width  }) {
    const { 0: qrCodeImg , 1: setQrCodeImg  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!phoneNumber) return;
        const fetchQr = async ()=>{
            try {
                const value = `tel:${phoneNumber}`;
                const url = await qrcode__WEBPACK_IMPORTED_MODULE_2__.toDataURL(value);
                setQrCodeImg(url);
            } catch (err) {
                ;
            }
        };
        void fetchQr();
    }, [
        phoneNumber
    ]);
    if (phoneNumber == undefined || phoneNumber == "") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "qrContainer",
        children: qrCodeImg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: qrCodeImg,
            alt: "QR Code",
            height: `${height ?? 100}px`,
            width: `${width ?? 100}px`
        })
    });
}


/***/ }),

/***/ 10621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProxiedNumber; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_svg_callCenterIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86106);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var src_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21513);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27713);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _components_severalbrands_partnerWithUsPage_formSection_icons_phoneIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50831);
/* harmony import */ var _QrCodeImage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83133);









function ProxiedNumber({ slogan , iconColor , textColor , emptyIcon , phoneNumberColor , stickyStyle , hideSticky , icon , phoneNumberClassName , iconPath  }) {
    const { category , headerOffer , stickyOffer , domain , visitDetails , routeConfig , loadingOffers , ignoreSticky , buyerPhoneNumber , domainNameTranslation ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const qrTextBlock = domain?.textBlocks.find((txtBlock)=>txtBlock.position === "qr-code-sticky-message");
    const isDesktop = visitDetails?.platform === "desktop";
    const callUsStickyTitle = domain?.config?.callUsStickyTitle || category?.config?.callUsStickyTitle || domain?.translations?.[`${domainNameTranslation}_CALL_US_STICKY_TITLE`] || "Call Us";
    const domainSlogan = (routeConfig?.config?.settings?.slogan || domain.slogan)?.replace(/\[s\]/gi, visitDetails?.region ?? "");
    let phoneNumber;
    // Prioritize buyer phone number from API call over offer phone numbers
    if (buyerPhoneNumber) {
        phoneNumber = buyerPhoneNumber;
    } else if (category && headerOffer?.length) {
        phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(headerOffer[0]);
    } else {
        phoneNumber = "";
    }
    const stickyPhoneNumber = buyerPhoneNumber ? buyerPhoneNumber : stickyOffer?.length ? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(stickyOffer[0]) : "";
    const qrText = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .renderQrText */ .p9)(qrTextBlock?.text, stickyPhoneNumber);
    let stickyOfferType = "";
    let stickyTitle = "";
    let stickyLink = "";
    let stickyButtonLabel = "";
    /* Sticky mobile config from variant config */ const stickyTitleFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.stickyMobileConfig?.label;
    const buttonLabelFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.stickyMobileConfig?.buttonLabel;
    const buttonIconFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.stickyMobileConfig?.icon;
    /* Sticky mobile config variant config*/ if (category && stickyOffer?.length && !hideSticky) {
        const stickyPhoneNumberMessage = category.config?.stickyPhoneNumberMessage;
        if (stickyPhoneNumber) {
            // number Offer
            stickyOfferType = "numberOffer";
            stickyTitle = stickyOffer[0].attributes?.phoneNumberMessage ? stickyOffer[0].attributes?.phoneNumberMessage : stickyOffer[0].hiddenAttributes?.phoneNumberMessage ? stickyOffer[0].hiddenAttributes?.phoneNumberMessage : stickyPhoneNumberMessage ? stickyPhoneNumberMessage : "Call Now to Get the Best Deal";
            stickyLink = `tel:${stickyPhoneNumber}`;
        } else {
            // link Offer
            stickyOfferType = "linkOffer";
            stickyTitle = stickyOffer[0].attributes?.stickyOfferMessage ? stickyOffer[0].attributes?.stickyOfferMessage : "";
            stickyLink = `/offers/${stickyOffer[0].slug}`;
            stickyButtonLabel = stickyOffer[0].attributes?.stickyOfferBtnLabel ? stickyOffer[0].attributes?.stickyOfferBtnLabel : "";
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const banner = document.getElementById("stickyOfferBanner");
        const claimsSection = document.getElementById("section-0");
        if (ignoreSticky && banner && claimsSection) {
            banner.classList.add("hidden");
            const observer = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) {
                    // Hero section is in view → user is at the top
                    banner.classList.add("hidden");
                } else {
                    // Hero section is out of view → user scrolled down
                    banner.classList.remove("hidden");
                }
            }, {
                threshold: 0.65
            });
            observer.observe(claimsSection);
        }
    }, []);
    // Show offers when: page offers are not hidden OR buyer has phone number override
    const shouldShowOffers = !routeConfig?.config?.settings?.hidePageOffers || !!buyerPhoneNumber;
    const shouldShowSticky = stickyOffer?.length && !hideSticky && shouldShowOffers;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            shouldShowSticky ? isDesktop && qrText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stickyQR)} ${ignoreSticky ? "hidden" : ""}`,
                id: "stickyOfferBanner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().qrCodeContainer)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_QrCodeImage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            phoneNumber: stickyPhoneNumber,
                            height: "100px",
                            width: "100px"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().qrText)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: qrText ?? ""
                            },
                            onClick: (e)=>{
                                const target = e.target;
                                if (target.tagName === "A" && target.dataset.phone) {
                                    void (0,src_api__WEBPACK_IMPORTED_MODULE_4__/* .callEvent */ .dr)({
                                        event: "Call",
                                        phoneNumber: target.dataset.phone
                                    });
                                }
                            }
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                href: `${stickyLink}`,
                onClick: ()=>{
                    if (stickyOfferType === "numberOffer") {
                        void (0,src_api__WEBPACK_IMPORTED_MODULE_4__/* .callEvent */ .dr)({
                            event: "Call",
                            phoneNumber: stickyPhoneNumber
                        });
                    }
                },
                style: {
                    "--text-color": stickyStyle?.stickTitleColor,
                    "--button-text-color": stickyStyle?.stickBtnTxtColor ?? domain.config?.stickyButtonTextColor,
                    "--button-bg-color": stickyStyle?.stickBtnBgColor ?? domain.config?.stickyButtonBgColor,
                    "--button-border-color": stickyStyle?.stickBtnBorderColor,
                    "--button-pulse-color": stickyStyle?.stickyPulseColor ?? domain.config?.stickyPulseColor ?? "191, 10, 47",
                    "--max-width": stickyStyle?.maxWidth ?? "80rem"
                },
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sticky)} rtlStyle ${ignoreSticky ? "hidden" : ""}  items-center`,
                id: "stickyOfferBanner",
                children: [
                    stickyTitleFromVariantConfig ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: `${stickyTitleFromVariantConfig}`
                            }
                        })
                    }) : stickyTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: `${stickyTitle}`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `flex items-center ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttonStyle)} ltrStyle`,
                        style: {
                            minWidth: "142px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-sm lg:text-lg font-bold md:font-normal flex gap-[2px] md:gap-2 items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().desktopIcon)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().phoneIcon)}  h-[20px] md:h-8 w-[20px] md:w-8`,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_partnerWithUsPage_formSection_icons_phoneIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        color: "currentColor"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().mobileIcon)}   h-[20px] md:h-8 w-[20px] md:w-8 relative`,
                                    children: buttonIconFromVariantConfig ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: buttonIconFromVariantConfig,
                                        alt: `Mobile Call Icon`
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_partnerWithUsPage_formSection_icons_phoneIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        color: "currentColor"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().number),
                                    children: stickyOfferType === "numberOffer" ? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(stickyPhoneNumber) : stickyButtonLabel
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().numberMobile),
                                    children: buttonLabelFromVariantConfig ? buttonLabelFromVariantConfig : stickyOfferType === "numberOffer" ? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(stickyPhoneNumber) : stickyButtonLabel
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: `hidden md:inline text-lg font-normal ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["call-us"])}`,
                                    children: callUsStickyTitle
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            phoneNumber && shouldShowOffers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().phoneNumber)} ${phoneNumberClassName ?? ""}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        className: `flex items-center `,
                        href: `tel:${phoneNumber}`,
                        style: {
                            "--text-color": phoneNumberColor ?? textColor,
                            "--icon-color": iconColor ?? textColor
                        },
                        onClick: ()=>{
                            void (0,src_api__WEBPACK_IMPORTED_MODULE_4__/* .callEvent */ .dr)({
                                event: "Call",
                                phoneNumber: phoneNumber
                            });
                        },
                        children: [
                            iconPath ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: iconPath,
                                className: "w-7 h-7 lg:w-9 lg:h-9 mr-2",
                                alt: `Call Icon`
                            }) : icon ?? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_callCenterIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: "w-7 h-7 lg:w-9 lg:h-9 mr-2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-sm lg:text-lg font-bold `,
                                children: loadingOffers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().loading)
                                }, phoneNumber) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().animatePhoneNumber),
                                    children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber)
                                }, phoneNumber)
                            })
                        ]
                    }),
                    headerOffer && (headerOffer[0]?.hiddenAttributes?.phoneNumberMessage || headerOffer[0]?.attributes?.phoneNumberMessage) && headerOffer[0]?.hiddenAttributes?.showHeaderPhoneNumber ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().phoneNumberMessage),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                fontSize: "11px",
                                color: phoneNumberColor ?? textColor ?? "#000"
                            },
                            dangerouslySetInnerHTML: {
                                __html: `${headerOffer[0].hiddenAttributes?.phoneNumberMessage ?? headerOffer[0].attributes?.phoneNumberMessage} `
                            }
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "hidden lg:flex items-center",
                style: {
                    "--text-color": textColor ?? phoneNumberColor
                },
                children: [
                    emptyIcon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slogan)} ml-3 `,
                        children: domainSlogan ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: `${domainSlogan} `
                            }
                        }) : slogan ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: slogan[0].toUpperCase()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "lowercase",
                                    children: slogan.slice(1)
                                })
                            ]
                        }) : ""
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 86106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CallCenterIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CallCenterIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        fill: "none",
        viewBox: "0 0 100 100",
        className: className ?? "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: fill ?? "#000",
            fillRule: "evenodd",
            d: "M55.593 93.297a7.215 7.215 0 01-7.104 5.89c-3.988 0-7.221-3.22-7.221-7.19 0-3.972 3.233-7.19 7.221-7.19a7.225 7.225 0 016.423 3.898c19.102-2.683 29.983-11.136 32.641-25.357-1.133.603-2.692-.386-4.677-2.968 0 0-7.57 17.754-19.538 20.67 17.51-14.738 5.792-37.794 3.174-42.574-2.618-4.78-3.624-6.694-4.849.999-2.84 12.297-30.994 5.092-35.061 16.062-2.712 7.314.604 16.086 9.948 26.316-10.126-3.079-17.001-9.73-20.624-19.952C11.485 68.329 3.16 63.274 3 59.26V40.364c.004-3.38 1.985-5.488 5.942-6.322 8.587-42.238 69.546-45.8 80.114-1.489 4.971 0 7.62 1.975 7.944 5.923l-.426 18.425c.048 2.922-1.37 5.071-4.253 6.447-3.84 16.7-16.082 26.683-36.728 29.95zm-39.41-56.535C23.38 20.998 34.653 13.43 50 14.057c21.029.774 30.198 15.997 32.166 22.705l.91-.899C77.693 16.976 66.411 7.533 49.23 7.533c-17.181 0-28.464 9.443-33.847 28.33l.8.9z",
            clipRule: "evenodd"
        })
    });
}


/***/ }),

/***/ 27713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"styles_slogan__fN4Lm","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","loading":"styles_loading__7ekNo","shimmer":"styles_shimmer__CFU1w","animatePhoneNumber":"styles_animatePhoneNumber__63E05","numberFadeIn":"styles_numberFadeIn__xB_QS","phoneNumberMessage":"styles_phoneNumberMessage___4IIV","phoneNumber":"styles_phoneNumber__0zuoL","numberMobile":"styles_numberMobile__XnrnH","number":"styles_number__yQTS1","stickyQR":"styles_stickyQR__JISKp","qrCodeContainer":"styles_qrCodeContainer__n28_6","qrText":"styles_qrText__GPFsk","phoneLink":"styles_phoneLink__yy0SC","sticky":"styles_sticky___B71c","buttonStyle":"styles_buttonStyle__uEeCJ","slideIn":"styles_slideIn__v__iW","shadow-pulse":"styles_shadow-pulse__U1Btk","call-us":"styles_call-us__R_IBH","phoneIcon":"styles_phoneIcon__FYZDe","jump-shaking":"styles_jump-shaking__BxJeE","desktopIcon":"styles_desktopIcon__Z1IZa","mobileIcon":"styles_mobileIcon__HlL4w"};

/***/ })

}]);